<div class="container">
  <h3 *ngIf="success">{{ 'CHANGE_PASSWORD_SUCCESS_TITLE' | translation }}</h3>
  <h3 *ngIf="!success">{{ 'CHANGE_PASSWORD_FAILED_TITLE' | translation }}</h3>
  <p *ngIf="success">{{ 'CHANGE_PASSWORD_SUCCESS_MSG' | translation }}</p>
  <p *ngIf="!success">{{ 'CHANGE_PASSWORD_FAILED_MSG' | translation }}</p>
  <div class="actions">
    <button (click)="closeModal()"> {{ 'ACCEPT' | translation }} </button>
  </div>
</div>
